export const Modal = {
    baseStyle: {
        dialog: {
            bgColor: "neutral.900",
            borderRadius: "2rem",
            overflowY: "auto",
            overflowX: "hidden",
        },
        header: {
            fontWeight: 500,
            color: "white",
            px: 8,
            pb: 0,
        },
        body: {
            overflowY: "auto",
            overflowX: "hidden",
            height: "100%",
            flexGrow: 1,
        },
        footer: {
            color: "neutral.200",
            px: 8,
            py: 4,
        },
        closeButton: {
            _focusVisible: {
                boxShadow: "none",
            },
        },
    },
    sizes: {
        md: {
            dialog: {
                maxWidth: "30vw",
            },
        },
        lg: {
            dialog: {
                maxWidth: "30vw",
                minWidth: "30rem",
            },
        },
    },
    variants: {
        standard: {
            dialog: {
                minWidth: "24rem",
                minHeight: "12rem",
                p: 2,
            },
            body: {
                color: "message",
                px: 8,
                py: 4,
            },
        },
        custom: {
            dialog: {
                minWidth: "83.33%",
                minHeight: "80%",
                maxHeight: "80%",
                p: 0,
                overflow: "hidden",
                height: "100%",
            },
            body: {
                px: 0,
                py: 0,
                overflow: "hidden",
                height: "100%",
            },
        },
        full: {
            overlay: {
                bg: "none",
            },
            dialog: {
                bgColor: "neutral.900",
                borderRadius: "0",
                p: 0,
                m: "auto",
                width: "100vw",
                height: "100%",
                minWidth: "100vw",
                minHeight: "100vh",
                maxHeight: "100vh",
                overflowY: "auto",
                overflowX: "hidden",
                pb: 28,
            },
            header: {
                fontSize: "2em",
                fontWeight: 500,
                color: "white",
                px: 8,
                pt: 16,
                pb: 6,
            },
            footer: {
                mt: 8,
            },
        },
        auto: {
            dialog: {
                w: "auto",
                h: "auto",
            },
        },
    },
    defaultProps: {
        size: "md",
        variant: "standard",
    },
};
